export const fbConfig = {
  apiKey: "AIzaSyCO-xRpsQJ5wD-Zk0nid6ljSk-J7fwvuU4",
  authDomain: "barometer-disco.firebaseapp.com",
  databaseURL: "https://barometer-disco.firebaseio.com",
  projectId: "barometer-disco",
  storageBucket: "barometer-disco.appspot.com",
  messagingSenderId: "607560955259"
};

export const appConfig = {
  id: fbConfig.projectId,
  appName: "DISCO",
  email: "iris.roose@ugent.be",
  logo: "DISCO",
  functions_url: "https://us-central1-barometer-disco.cloudfunctions.net",
  templates: false,
  home: "/start",
  homeSurvey: "/survey/view/oHHAvZZm88LO6QqCeNzd",
  share_prefix: "barometersdl",
  register_as_individual: true,
  register_as_group: true,
  hide_disclaimer: false,
  hide_boarding: false,
  color1: "#53bc76",
  color2: "#348a66",
  languages: [
    { key: "nl_BE", label: "Nederlands", labelNL: "Nederlands", default: true },
    { key: "fr_BE", label: "Français", labelNL: "Frans" },
    { key: "en_GB", label: "English", labelNL: "Engels" }
  ],
  multilanguage_app: true,
  field_types: [
    {
      label: "Sectie",
      value: "fieldset",
      roles: ["creator", "admin", "mentor"]
    },
    { label: "Titel", value: "legend", roles: ["creator", "admin"] },
    {
      label: "Textveld (open vraag)",
      value: "text",
      roles: ["creator", "admin", "mentor"]
    },
    {
      label: "Keuzelijst",
      value: "list",
      roles: ["creator", "admin", "mentor"]
    },
    {
      label: "Ja/Nee",
      value: "boolean",
      roles: ["creator", "admin", "mentor"]
    },
    { label: "Email", value: "email", roles: ["creator", "admin"] },
    { label: "Datum", value: "date", roles: ["creator", "admin"] },
    { label: "Nummer", value: "number", roles: ["creator", "admin"] },
    { label: "Verborgen", value: "hidden", roles: ["creator", "admin"] },
    {
      value: "scale1",
      label: "Schaal (7 punten)",
      options: [
        { label: "---", value: 0 },
        { label: "--", value: 1 },
        { label: "-", value: 2 },
        { label: "-+", value: 3 },
        { label: "+", value: 4 },
        { label: "++", value: 5 },
        { label: "+++", value: 6 }
      ],
      roles: ["creator", "admin", "mentor"]
    },
    {
      value: "scale1_inverse",
      label: "Schaal (7 punten - omgekeerd)",
      options: [
        { label: "---", value: 6 },
        { label: "--", value: 5 },
        { label: "-", value: 4 },
        { label: "-+", value: 3 },
        { label: "+", value: 2 },
        { label: "++", value: 1 },
        { label: "+++", value: 0 }
      ],
      roles: ["creator", "admin", "mentor"]
    },
    {
      value: "scale2",
      label: "Schaal (9 punten)",
      options: [
        { label: "(0) Niet", value: 0, key: 0 },
        { label: "(1)", value: 1, key: 1 },
        { label: "(2) Weinig", value: 2, key: 2 },
        { label: "(3)", value: 3, key: 3 },
        { label: "(4) Een beetje", value: 4, key: 4 },
        { label: "(5)", value: 5, key: 5 },
        { label: "(6) Redelijk", value: 6, key: 6 },
        { label: "(7)", value: 7, key: 7 },
        { label: "(8) Veel", value: 8, key: 8 }
      ],
      roles: ["creator", "admin", "mentor"]
    },
    {
      value: "scale2_inverse",
      label: "Schaal (9 punten - omgekeerd)",
      options: [
        { label: "Niet", value: 8, key: 8 },
        { label: "", value: 7, key: 7 },
        { label: "Weinig", value: 6, key: 6 },
        { label: "", value: 5, key: 5 },
        { label: "Een beetje", value: 4, key: 4 },
        { label: "", value: 3, key: 3 },
        { label: "Redelijk", value: 2, key: 2 },
        { label: "", value: 1, key: 1 },
        { label: "Veel", value: 0, key: 0 }
      ],
      roles: ["creator", "admin", "mentor"]
    }
  ],
  results_hide_for_mentor: false,
  results: [
    {
      id: "1_1",
      surveyKey: "oHHAvZZm88LO6QqCeNzd",
      key: "cw3IiH2F8Kv6JRGJyPH0",
      branches: [
        {
          label: "Gender & Holibiseksualiteit",
          match: [
            "zEIWFRF2XGlA2nKHGT7B",
            "iPZ2Hm8ZrcQGlQ66Mi3L",
            "y9QSUzHKB8zbWEBaFw4p",
            "cw3IiH2F8Kv6JRGJyPH0",
            "PhNoa2xb2oiqXRSlboS2",
            "wuDzbOCaP6LLlqqNm47W",
            "h2s6LJWKJX539Ons3sVx",
            "sA57KyG3vmayGw0pPCqi"
          ],
          reference: 4.81
        },
        {
          label: "Etniciteit",
          match: [
            "8RL9cBaAl6xYkEVayNks",
            "jLKzUWlJKakIOPyobDNZ",
            "VudFWkYtHg1OoBLLfNJk",
            "I7bY8kogmJITgZO4qDjy",
            "CUNXwz7hZYoKZ1gS5BvF",
            "zgt92CocRHLpBByJvptG"
          ],
          reference: 3.78
        },
        {
          label: "Sociaal-economische achtergrond",
          match: [
            "3zmknbyaz3NEKJTXuA31",
            "9EnnVRTNmmyRh3odCuvR",
            "Y5hCRTJFhTHyxeQGW6my",
            "kv7i4qn4mFGQk1va5Xg2",
            "lDB3sEN1u64QXPOCS5qr"
          ],
          reference: 3.28
        },
        {
          label: "Beperkingen",
          match: [
            "s0887nYxsUJvS5IFmQLl",
            "BzakV9mWP7uuxqksecbD",
            "aiTTI4tvdEIpUCgwmxow",
            "cw3IiH2F8Kv6JRGJyPH0",
            "rYfplt3kn8e9AGVvmkkr"
          ],
          reference: 3.83
        }
      ]
    },
    {
      id: "1_2",
      surveyKey: "oHHAvZZm88LO6QqCeNzd",
      key: "4Nf12jRi56OGzAQ6eYIo",
      reference: 3.9
    },
    {
      id: "2_1",
      surveyKey: "oHHAvZZm88LO6QqCeNzd",
      key: "viaKmvn4KBxs2aLh2I0x",
      intro:
        "<b>A. OOG VOOR DIVERSITEIT IN AL HAAR FACETTEN</b><p>Deze score geeft aan in welke mate je diversiteit breed observeert. Hoe je op zoek gaat naar informatie over leerlingen in hun geheel (leerkenmerken, interesses, hobby’s, vriendschappen) en in verschillende contexten (op school, thuis, in de vriendenkring, op de speelplaats, etc.). Al deze informatie kan immers nuttig zijn om diversiteit volop te benutten in de klas en op school.</p> ",
      branches: [
        { match: "RgEPrCawx7P6pNTUy7jG", reference: 5.03 },
        { match: "vSCHesvG3TUt5RDoNzp4", reference: 5.31 },
        { match: "L1wpUdyFlvFswSRWni5r", reference: 5.85 },
        { match: "i0YhucMfndOb0Qqd1YE4", reference: 6.16 },
        { match: "Wmhe0K0vfs0taj6DzGqM", reference: 5.09 }
      ]
    }
  ]
}; //http://localhost:5000
